import React from "react";

function Laste10TransTable(props) {
  const { data } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper tax-table">
        <table className="table last-column">
          <thead>
            <>
              <tr className="">
                <th scope="col">Date</th>
                <th scope="col">Symbol</th>
                <th scope="col">Exchange</th>
                <th scope="col">QTY</th>
                <th scope="col">Price</th>
                <th scope="col">Value</th>
                <th scope="col">Mode</th>
              </tr>
            </>
          </thead>
          <tbody>
            {data &&
              data.map((item, key) => {
                return (
                  <>
                    <tr key={key} className="">
                      <td>{item?.date || "-"}</td>
                      <td>{`${item?.symbol || "-"}  (${
                        item?.action || "-"
                      })`}</td>
                      <td>{item?.exchange || ""}</td>
                      <td>{item?.qty || 0}</td>
                      <td>{item?.price || 0}</td>
                      <td>{item?.value || 0}</td>
                      <td>{item?.mode || ""}</td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default Laste10TransTable;
